import { $set, update } from 'qim';

import ActionTypes from 'app/contact-us/ActionTypes';
import { createReducer } from 'app/common/utils/ReduxUtils';
import { uuidv4 } from 'app/common/CommonUtils';

const initialState = {
  attemptId: null,
};

const handlers = {
  [ActionTypes.RESET_ATTEMPT_ID](state) {
    return update(['attemptId', $set(uuidv4())], state);
  },
};

const reducer = createReducer(handlers, initialState);

export default reducer;
